import { StringTableService } from './../../services/string-table.service';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild
} from '@angular/core';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../base/base.component';
import { HeaderToolbarComponent } from '../header-toolbar/header-toolbar.component';
import { HeaderComponent } from '../header/header.component';
import { MainNavbarComponent } from '../main-navbar/main-navbar.component';
import { PageViewComponent } from '../page-view/page-view.component';

@Component({
  selector: 'app-main-component',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent extends BaseComponent implements AfterViewInit, OnInit {
  static cdr;
  static currentPageViewID = 0;
  static atcList;
  static trainingList;

  @ViewChild('scrollPage') private scrollContainer: ElementRef;

  @ViewChild('header') public header: HeaderComponent;

  @ViewChild('primaryTabBar') public primaryTabBar: MainNavbarComponent;

  @ViewChild('home') home: PageViewComponent;

  @Input() currentPageViewID = 0;

  @Input() adminClientId;

  private doNotRoute = false;

  static getTrainingList() {
    return MainComponent.trainingList;
  }
  static getAtcData() {
    return MainComponent.atcList;
  }
   static setAtcData(data) {
    MainComponent.atcList = data;
    MainComponent.cdr.detectChanges();
  }
  static setTrainingList(data) {
    MainComponent.trainingList = data;
    MainComponent.cdr.detectChanges();
  }

  listPageViews: Array<PageViewComponent> = [];

  constructor(private elementRef: ElementRef, private cdr: ChangeDetectorRef,
    protected router: Router, stringTableService: StringTableService, private route: ActivatedRoute) {
    super(elementRef);
    MainComponent.cdr = this.cdr;
    const queryParam = (stringTableService.getString('reviewModeParams', 'queryParam2'));
    route.queryParams.subscribe((params) => {
      if (params[queryParam] && params[queryParam] === '1') {
        this.doNotRoute = true;
      } else {
        this.doNotRoute = false;
      }
    });
  }

  ngOnInit() {
    if (this.doNotRoute) {
      return;
    }
    if (this.adminClientId === '0') {
      this.router.navigate(['super-admin']);
    }
  }

  ngAfterViewInit() {
    this.listPageViews.push(this.home);
  }

  onClick(event) {
    if (this.isReviewMode) {
      return;
    }
    this.currentPageViewID = 0;
    this.cdr.detectChanges();
    this.currentPageViewID = event.index;
    this.cdr.detectChanges();
    this.router.navigate(['home']);
  }

  onTabChanged(event) {
    this.scrollContainer.nativeElement.scrollTop = 0;
  }

}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/main-component/main.component.ts